/* eslint-disable react/forbid-prop-types */
/* eslint-disable-next-line max-len */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Row, Col, Card, CardText, CardBody, Table } from 'reactstrap';
import PropTypes, { element, object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { setCurrencyFormat } from '../../../../utils/helpers';
import { colorArr, sortByOptions } from '../../helper';



const YearTable = ({ dataToShowForDatesSelected, month,
  title, filterBasedOnFilter, categorisedBasedOn, firstColumn, currentlyShow }) => {
  const { t } = useTranslation('common');
  const categorisedBasedOnRef = useRef({ categorisedBasedOn });

  const [selectedOptions, setSelectedOptions] = useState([])
  const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])
  const allCategories = {}
  const currentDataByCategory = {};

  useEffect(() => {
    if (categorisedBasedOnRef?.current?.categorisedBasedOn !== categorisedBasedOn) {
      setSelectedOptions([])
    }
  }, [categorisedBasedOn])

  const changeFilter = (value) => {
    setSelectedOptions(value)
  };

  dataToShowForDatesSelected.forEach((item) => {
    if (item && currentDataByCategory[item?.[categorisedBasedOn]]) {
      currentDataByCategory[item?.[categorisedBasedOn]]?.push(item)
    } else if (item) {
      if (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null') {
        currentDataByCategory?.['N/A']?.push(item)
      } else {
        currentDataByCategory[item?.[categorisedBasedOn]] = [item]
      }
    }
  });

  const currentMonthCat = Object.keys(currentDataByCategory);
  let dataToPlot = [];
  const options = [];

  const reduceCallback = (acc, day) => {
    const date = moment(`${day?.salesYear}`, 'YYYY');
    const Year = date.format('YYYY');
    if (acc[Year]) {
      acc?.[Year]?.push(day)
    } else {
      acc[Year] = [day]
    }

    if (day && !allCategories[day?.[categorisedBasedOn]]) {
      if (!day?.[categorisedBasedOn] || day?.[categorisedBasedOn] === 'null') {
        allCategories['N/A'] = 'N/A';
      } else {
        allCategories[day?.[categorisedBasedOn]] = day?.[categorisedBasedOn]
      }
    }
    return acc
  }

  const getPercentage = (currValue, preValue) => {
    let v = 0;
    if (preValue > 0) {
      v = (((currValue - preValue) / preValue) * 100).toFixed(2) || '0.00';
    }
    else {
      v = 0;
    }
    return v;
  }

  const getColorCode = (salesPer) => {
    let colorCode;

    if (salesPer < 0) {
      const negValue = salesPer.split('-');
      if (negValue[1] < 10) {
        colorCode = colorArr[0].toString();
      }
      else if (negValue[1] > 10 && negValue[1] < 20) {
        colorCode = colorArr[1].toString();
      }
      else if (negValue[1] > 20 && negValue[1] < 30) {
        colorCode = colorArr[2].toString();
      }
      else if (negValue[1] > 30 && negValue[1] < 40) {
        colorCode = colorArr[3].toString();
      }
      else if (negValue[1] > 40 && negValue[1] < 50) {
        colorCode = colorArr[4].toString();
      }
      else if (negValue[1] > 50 && negValue[1] < 60) {
        colorCode = colorArr[5].toString();
      }
      else if (negValue[1] > 60 && negValue[1] < 70) {
        colorCode = colorArr[6].toString();
      }
      else if (negValue[1] > 70 && negValue[1] < 80) {
        colorCode = colorArr[7].toString();
      }
      else if (negValue[1] > 80 && negValue[1] < 90) {
        colorCode = colorArr[8].toString();
      }
      else if (negValue[1] > 90) {
        colorCode = colorArr[9].toString();
      }
    }
    else if (salesPer > 0) {
      if (salesPer < 10) {
        colorCode = colorArr[10].toString();
      }
      else if (salesPer > 10 && salesPer < 20) {
        colorCode = colorArr[11].toString();
      }
      else if (salesPer > 20 && salesPer < 30) {
        colorCode = colorArr[12].toString();
      }
      else if (salesPer > 30 && salesPer < 40) {
        colorCode = colorArr[13].toString();
      }
      else if (salesPer > 40 && salesPer < 50) {
        colorCode = colorArr[14].toString();
      }
      else if (salesPer > 50 && salesPer < 60) {
        colorCode = colorArr[15].toString();
      }
      else if (salesPer > 60 && salesPer < 70) {
        colorCode = colorArr[16].toString();
      }
      else if (salesPer > 70 && salesPer < 80) {
        colorCode = colorArr[17].toString();
      }
      else if (salesPer > 80 && salesPer < 90) {
        colorCode = colorArr[18].toString();
      }
      else if (salesPer > 90) {
        colorCode = colorArr[19].toString();
      }
    }
    else {
      colorCode = colorArr[20].toString();
    }
    return colorCode;
  }

  for (let i = 0; i < currentMonthCat.length; i += 1) {
    const cat = currentMonthCat[i];
    const currentMonth = currentDataByCategory?.[cat] ?? [];
    let currentYearMonthMax = 0;
    currentMonth?.forEach((item) => {
      currentYearMonthMax += Number(item.amount)
    }
    );
    const currentYearMonthDayWise = currentMonth?.reduce(reduceCallback, {})
    const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, monthyear) => {
      const date = moment(`${monthyear}`, 'YYYY');
      const preMonthYear = moment(date).subtract(1, 'year').endOf('year').format('YYYY');
      let amount = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
        Number(item.amount)).toFixed(2)), 0);
      amount = Math.abs(amount);
      const orderCount = currentYearMonthDayWise[monthyear]?.reduce((accOrder, itemOrder) =>
        Number(Number(accOrder) + Number(itemOrder.orderCount)), 0)
      let preAmount = currentYearMonthDayWise[preMonthYear]?.reduce((accPre, item) =>
        Number(Number(Number(accPre) + Number(item.amount)).toFixed(2)), 0) ?? 0;

        preAmount = preAmount < 0 ? preAmount*-1 : preAmount;

      const percentageAmount = getPercentage(amount, preAmount) ?? 0;
      const cardColorCode = getColorCode(percentageAmount);
      acc[monthyear] = {
        Amount: amount, OrderCount: orderCount,
        salesPercentage: percentageAmount, ColorCode: cardColorCode
      };
      return acc
    }, {})
    options.push({
      value: cat, label: cat
    })

    dataToPlot.push({
      title: cat,
      categoryWiseAmountTotal,
      currentYearMonthMax: currentYearMonthMax > 0 ? currentYearMonthMax : 0
    })

  }

  if (selectedOptions?.length) {
    const selected = selectedOptions?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    dataToPlot = dataToPlot.filter(item => selected[item.title])
  }

  const sortBy = sortBySelected?.value;
  if (sortBy === 'title') {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
  } else {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy] < b?.[sortBy] ? 1 : -1)
  }
  return (

    <div className="card__title row">
      <h5 className="bold-text col-md-5">{title}</h5>
      <div className="form__form-group mb-0 col-md-7" id="dvTable">
        <div className="row justify-content-center align-items-center">
          <div className="col-6">
            <span className="form__form-group-label font-weight-bold">
              {`Select ${currentlyShow?.value}`}</span>
            <div className="form__form-group-field">
              <Select
                value={selectedOptions}
                options={options}
                clearable={false}
                placeholder={`Select ${currentlyShow?.value}`}
                className="select_filter"
                onChange={changeFilter}
                classNamePrefix="react-select"
                isMulti
              />
            </div>
          </div>
          <div className="col-6">
            <span className="form__form-group-label font-weight-bold">Sort By</span>
            <div className="form__form-group-field">
              <Select
                value={sortBySelected}
                options={sortByOptions}
                clearable={false}
                placeholder="Sort By"
                className="select_filter"
                onChange={setSortBySelected}
                classNamePrefix="react-select"
              />
            </div>
          </div>
        </div>
      </div>
      <Table responsive striped className="dashboard__table-orders" width="100%">
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>{firstColumn}</th>
            {month.map((item, index) => (
              <th style={{ textAlign: 'center' }}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {dataToPlot?.length ? dataToPlot?.map(dataValue => (
            <tr>
              <td style={{ paddingTop: '4px', paddingBottom: '4px' }}>{dataValue.title}
              </td>
              {month.map((item, index) => (
                <td style={{
                  paddingTop: '2px', paddingBottom: '2px', marginLeft: '0px',
                  marginRight: '0px'
                }}>
                  <Card body style={{
                    background: dataValue?.categoryWiseAmountTotal?.[item]?.Amount > 0
                      ? dataValue?.categoryWiseAmountTotal?.[item]?.ColorCode : colorArr[20],
                    width: '120px',
                    height: '80px', marginBottom: '0px',
                    marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                    paddingRight: '6px'
                  }}>
                    <CardText style={{
                      color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                      paddingTop: '0px', marginBottom: '0px'
                    }}>
                      {setCurrencyFormat(dataValue?.categoryWiseAmountTotal?.[item]?.Amount, true)}
                    </CardText>
                    {dataValue?.categoryWiseAmountTotal?.[item]?.salesPercentage < 0 && (
                      <CardText style={{
                        color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                        paddingTop: '0px', marginBottom: '0px'
                      }}>
                        <span>
                          <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                            <path
                              d="M16,18L18.29,15.71L13.41,10.83L9.41,14.83L2,7.41L3.41,6L9.41,12L13.41,8L19.71,
                                                  14.29L22,12V18H16Z"
                            />
                          </svg>
                          {dataValue?.categoryWiseAmountTotal?.[item]?.salesPercentage}%
                        </span>
                      </CardText>
                    )}
                    {dataValue?.categoryWiseAmountTotal?.[item]?.salesPercentage > 0 && (
                      <CardText style={{
                        color: '#000000', fontSize: '11px',
                        textAlign: 'right', paddingBottom: '0px',
                        paddingTop: '0px', marginBottom: '0px'
                      }}>
                        <span>
                          <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                            <path
                              d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,
                                                12L13.41,16L19.71,9.71L22,12V6H16Z"
                            />
                          </svg>
                          {dataValue?.categoryWiseAmountTotal?.[item]?.salesPercentage}%
                        </span>
                      </CardText>
                    )}
                    {dataValue?.categoryWiseAmountTotal?.[item]?.salesPercentage === 0 && (
                      <CardText style={{
                        color: '#000000', fontSize: '11px',
                        textAlign: 'right', paddingBottom: '0px',
                        paddingTop: '0px', marginBottom: '0px'
                      }}>
                        <span>

                          {dataValue?.categoryWiseAmountTotal?.[item]?.salesPercentage}%
                        </span>
                      </CardText>
                    )}
                    {dataValue?.categoryWiseAmountTotal?.[item]?.salesPercentage === '0.00' && (
                      <CardText style={{
                        color: '#000000', fontSize: '11px',
                        textAlign: 'right', paddingBottom: '0px',
                        paddingTop: '0px', marginBottom: '0px'
                      }}>
                        <span>

                          {dataValue?.categoryWiseAmountTotal?.[item]?.salesPercentage}%
                        </span>
                      </CardText>
                    )}
                    <CardText style={{
                      color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                      paddingTop: '0px', marginBottom: '0px'
                    }}>
                      {setCurrencyFormat(dataValue?.categoryWiseAmountTotal?.[item]?.OrderCount, false)}
                    </CardText>
                  </Card>

                </td>
              ))}
            </tr>
          )) : 'No data to display'}
        </tbody>
      </Table>
    </div>

  )
}

YearTable.propTypes = {
  dataToShowForDatesSelected: PropTypes.array.isRequired,
  firstColumn: PropTypes.string,
  month: PropTypes.object.isRequired,
  title: PropTypes.string,
  filterBasedOnFilter: PropTypes.func.isRequired,
  categorisedBasedOn: PropTypes.string,
  currentlyShow: PropTypes.object.isRequired
};

YearTable.defaultProps = {
  title: 'Category Sales By Year',
  firstColumn: 'Product Category',
  categorisedBasedOn: 'productCategory',
}

export default YearTable;

